import { hourMs, minuteMs } from 'components/date_time/time';

// Free of data-layer imports (sdClient, react-query, utils/node) so the V4 form components
// can read these types and constants without pulling the heavy useV4SensorSettings module
// into a load-time import cycle.

export type YAxisCollection =
    | { enabled: false }
    | {
          enabled: true;
          samplingFrequencyHz: number;
          numberOfSamples: number;
      };

export type UpdateInterval =
    | { mode: 'smartsample' }
    | {
          mode: 'triggered';
          thresholdG: number;
          collectionOffsetMs: number;
          minTimeBetweenTriggersMs: number;
      }
    | { mode: 'timed'; intervalMs: number };

export type UpdateIntervalMode = UpdateInterval['mode'];

export const UPDATE_INTERVAL_MODE_LABELS: Record<UpdateIntervalMode, string> = {
    smartsample: 'SMARTsample',
    triggered: 'Triggered',
    timed: 'Timed',
};

export type V4SensorSettings = {
    vibrationX: boolean;
    vibrationY: boolean;
    vibrationZ: boolean;
    samplingFrequencyHz: number;
    numberOfSamples: number;
    lowFrequencyCollection: YAxisCollection;
    updateInterval: UpdateInterval;
    envelopedData: YAxisCollection;
    ultrasound: boolean;
    turningSpeed: boolean;
};

export const DEFAULT_LFC_ENABLED: Extract<YAxisCollection, { enabled: true }> = {
    enabled: true,
    samplingFrequencyHz: 2000,
    numberOfSamples: 2000,
};

export const DEFAULT_TRIGGERED: Extract<UpdateInterval, { mode: 'triggered' }> = {
    mode: 'triggered',
    thresholdG: 1,
    collectionOffsetMs: 0,
    minTimeBetweenTriggersMs: 10 * minuteMs,
};

export const DEFAULT_TIMED: Extract<UpdateInterval, { mode: 'timed' }> = {
    mode: 'timed',
    intervalMs: hourMs,
};

export const DEFAULT_ENVELOPED: Extract<YAxisCollection, { enabled: true }> = {
    enabled: true,
    samplingFrequencyHz: 2000,
    numberOfSamples: 1000,
};

export const defaultV4SensorSettings: V4SensorSettings = {
    vibrationX: true,
    vibrationY: true,
    vibrationZ: true,
    samplingFrequencyHz: 16000,
    numberOfSamples: 8000,
    lowFrequencyCollection: { enabled: false },
    updateInterval: { mode: 'smartsample' },
    envelopedData: DEFAULT_ENVELOPED,
    ultrasound: true,
    turningSpeed: true,
};
